export default "__VITE_PUBLIC_ASSET__83f2c54c__"